@if (isLoading()) {
  <div class="flex h-full items-center justify-center">Loading...</div>
} @else if (isUnsupportedEntityType()) {
  <div
    data-testid="unsupported-entity-type"
    class="flex h-full flex-col items-center justify-center gap-2 px-14 py-10 text-center">
    <span
      class="border-weak inline-flex size-12 items-center justify-center rounded-lg border">
      <i [class]="ICONS.warning" class="text-accent-main text-2xl"></i>
    </span>
    <p class="text-text-primary text-base font-semibold">
      {{ 'features.entities.edit.unsupported_title' | translate }}
    </p>
    <p class="text-text-tertiary max-w-xs text-xs font-normal">
      {{
        'features.entities.edit.unsupported_message'
          | translate: { entityType: entityType() }
      }}
    </p>
    <button type="button" class="btn btn-secondary mt-2" (click)="navigateToDataRoot()">
      {{ 'features.entities.edit.back_to_data' | translate }}
    </button>
  </div>
} @else if (schema()) {
  <div class="flex h-full w-full flex-col gap-1">
    <!-- Toolbox -->
    <app-toolbox [sections]="toolboxSections()" [showCustomContent]="true">
      <p class="font-medium">
        @if (formMode() === 'edit') {
          {{ 'features.entities.editing_line' | translate }}
          <span
            class="inline-flex items-center rounded-md bg-purple-100 px-1.5 py-0.5 text-xs font-medium text-purple-800 dark:bg-purple-900 dark:text-purple-300">
            {{ entityUid() }}
          </span>
        } @else {
          {{ 'features.entities.creating_line' | translate }}
        }
      </p>
    </app-toolbox>

    <!-- Form/JSON Editor + Visualization Split -->
    <as-split direction="vertical" class="flex-1 overflow-hidden">
      <as-split-area [size]="isVisuVisible() ? 60 : 100">
        @if (editorMode() === 'form') {
          <div class="flex h-full w-full gap-1">
            <app-row-edition-form
              #rowEditionForm
              [schema]="schema()!"
              [rowId]="entityUid() ?? ''"
              [actualValues]="actualValues()"
              [entityType]="entityType()"
              [formMode]="formMode()"
              (formValueChange)="onFormValueChange($event)"
              (formValidChange)="onFormValidChange($event)"
              class="h-full min-w-0 flex-1" />
            @if (compatibilitySession.isActive()) {
              <app-compatibility-requirement-panel appFocusFirst />
            }
          </div>
        } @else if (rawJsonSchema()) {
          <app-full-json-editor
            #fullJsonEditor
            [jsonSchema]="rawJsonSchema()!"
            [initialValues]="actualValues()"
            [formMode]="formMode()"
            (valueChange)="onJsonEditorValueChange($event)"
            (validChange)="onJsonEditorValidChange($event)"
            class="h-full w-full p-4" />
        }
      </as-split-area>

      @if (!isPopupOpen() && isVisuVisible()) {
        <as-split-area [size]="40">
          <app-data-visu class="h-full w-full overflow-hidden" [filteringEnabled]="false" />
        </as-split-area>
      }
    </as-split>
  </div>
} @else {
  <div class="flex h-full items-center justify-center">Entity not found</div>
}
